import React from 'react';
import { API_BASE } from '../utils/fileUtils';

interface AvatarCellProps {
  avatarPath?: string | null;
  name: string;
  subtitle?: string;
}

/**
 * Ячейка таблицы с аватаром пользователя.
 * Используется в AdminUsers и других местах, где нужен аватар + имя.
 */
const AvatarCell: React.FC<AvatarCellProps> = ({ avatarPath, name, subtitle }) => (
  <div className="avatar-cell">
    {avatarPath ? (
      <img
        src={`${API_BASE}/uploads/${avatarPath}`}
        alt={name}
        className="avatar avatar-cell__img"
      />
    ) : (
      <div className="avatar avatar-cell__placeholder">
        {name.charAt(0).toUpperCase()}
      </div>
    )}
    <div className="avatar-cell__info">
      <span className="avatar-cell__name">{name}</span>
      {subtitle && <span className="avatar-cell__sub">{subtitle}</span>}
    </div>
  </div>
);

export default AvatarCell;
